/**
 * At a certain point the modal becomes so height constrained that the content
 * (mostly buttons in the footer) become unactionable or visibly focused. This
 * become most apparent when browser zoomed between 200%-400% (accessibility
 * requirement)
 */
export const isHeightConstrained =
  `@media screen and (max-height: 403px)` as const
